import React, { useState, useEffect, useRef } from "react";
import { Formik, Form, Field } from "formik";
import { BsCash } from "react-icons/bs";
import * as Yup from "yup";
import config from "../../../../config/config";
import axios from "axios";
import Select from "react-select";
import Moment from "moment";
import { toastError, toastSuccess } from "../../../../common/Toast";
import { useParams, Link } from "react-router-dom";
import {
  ALREADY_EXIST,
  ERROR_EXISTS,
  ERROR_MESSAGE,
  SUCCESS_MESSAGE,
} from "../../../../common/Constant";
import { Button } from "react-bootstrap";
import Loader from "../../../../components/Loader/Loader";
import { checkUserPermission } from "../../../../common/UserPermission";

const Pricing = (props) => {
  const paramObject = useParams();
  const buttonRef = React.useRef(null);
  const Id = localStorage.getItem("ID");
  const token = localStorage.getItem("Token");
  const [taxGroup, setTaxGroup] = useState([]);
  const [loading, setLoading] = useState(false);
  const [taxGroupValues, setTaxGroupValues] = useState();
  const [commissionTypeValues, setCommissionTypeValues] = useState();
  const [
    commissionPercentCalculationMethodValues,
    setCommissionPercentCalculationMethodValues,
  ] = useState();

  // taxItem default value
  const [taxItem, setTaxItem] = useState([
    {
      tax1id: "",
      tax1: "",
      tax1Value: "",
      taxType1: "",

      tax2id: "",
      tax2: "",
      tax2Value: "",
      taxType2: "",

      tax3id: "",
      tax3: "",
      tax3Value: "",
      taxType3: "",

      tax4id: "",
      tax4: "",
      tax4Value: "",
      taxType4: "",

      tax5id: "",
      tax5: "",
      tax5Value: "",
      taxType5: "",
    },
  ]);

  console.log(taxItem, "taxItem");

  // Values to handle the true or false for the checkbox
  const [overDefaultTax, setOverDefaultTax] = useState(false);
  const [overrideDefaultCommission, setOverrideDefaultCommission] =
    useState(false);
  const [allowPrice, setAllowPrice] = useState(false);
  const [disablePrice, setDisablePrice] = useState(false);
  const [priceTax, setPriceTax] = useState(false);
  const [allowItems, setAllowItems] = useState(false);
  const [changePrice, setChangePrice] = useState(false);
  const [taxCummlative, setTaxCummlative] = useState(false);

  // Values to handle the 0 or 1 for the checkbox
  const [overDefaultTaxValues, setOverDefaultTaxValues] = useState(0);
  const [overrideDefaultCommissionValues, setOverrideDefaultCommissionValues] =
    useState(0);
  const [allowPriceValues, setAllowPriceValues] = useState(0);
  const [disablePriceValues, setDisablePriceValues] = useState(0);
  const [priceTaxValues, setPriceTaxValues] = useState(0);
  const [allowItemsValues, setAllowItemsValues] = useState(0);
  const [changePriceValues, setChangePriceValues] = useState(0);
  const [taxCummlativeValues, setTaxCummlativeValues] = useState(0);
  const [variationItem, setVariationItem] = useState([]);
  const [variationInputValues, setVariationInputValues] = useState([]);
  const [selectedCommissionType, setSelectedCommissionType] = useState(0);
  const [selectedCommissionPercent, setSelectedCommissionPercent] = useState(0);
  const [selectedTaxGroup, setSelectedTaxGroup] = useState(0);
  const [SubmitEvent, setSubmitEvent] = useState(0);
  const [taxGroupValue, setTaxGroupValue] = useState(0);
  const [allTierDiscountValues, setAllTierDiscountValues] = useState([]);
  const [allTierDiscountType, setAllTierDiscountType] = useState([
    "Percentage",
    "Percentage",
    "Percentage",
    "Percentage",
    "Percentage",
  ]);

  // ---------------------------------Rishabh-----------------------------------------

  // formValues default value
  const [formValues, setFormValues] = useState({
    cost: "",
    sell: "",
    promoprice: "",
    promoStartDate: "",
    promoEndDate: "",
    DisablePrice: "",
    AllowPrice: "",
    PriceTax: "",
    AllowItems: "",
    ChangePrice: "",
    Override: "",
    commission: "",
    commissionType: "",
    commissionPercentCalculationMethod: "",
    OverrideTax: "",
    Tier1: "",
    Tier1Type: "",
    Tier1Value: "",
    Tier2: "",
    Tier2Type: "",
    Tier2Value: "",
    Tier3: "",
    Tier3Type: "",
    Tier3Value: "",
    Tier4: "",
    Tier4Type: "",
    Tier4Value: "",
    Tier5: "",
    Tier5Type: "",
    Tier5Value: "",
    taxgroup: 0,
    InventoryAssetsDescription: "",
    InventoryAssetsAccountID: 0,
    ExpenseAccountDescription: "",
    ExpenseAccountID: 0,
    IncomeAccountDescription: "",
    IncomeAccountID: 0,
    tax1id: "",
    tax1: "",
    tax1Value: "",
    taxType1: "",

    tax2id: "",
    tax2: "",
    tax2Value: "",
    taxType2: "",

    tax3id: "",
    tax3: "",
    tax3Value: "",
    taxType3: "",

    tax4id: "",
    tax4: "",
    tax4Value: "",
    taxType4: "",

    tax5id: "",
    tax5: "",
    tax5Value: "",
    taxType5: "",
  });

  const [variationPricing, setVariationPricing] = useState([]);
  const [tierVariation, setTierVariation] = useState([]);
  const [otherOption, setOtherOption] = useState({});
  const [overRidevalue, setOverRidevalue] = useState({});

  const [tierPrices, setTierPrices] = useState({
    costPrice: "",
    sellPrice: "",
    promoprice: "",
    promoStartDate: "",
    promoEndDate: "",
  });

  // show other pricing options using checkbox-
  const [otherPricingOptions, setOtherPricingOptions] = useState({
    AllowPromotionOffer: 0,
    Overridedefaultcommission: 0,
    Overridedefaulttax: 0,
  });

  console.log(otherPricingOptions, "otherPricingOptions");

  const showOthersPricingOptions = (e) => {
    const { name, checked } = e.target;

    if (checked == true) {
      setOverRidevalue(1);
      setOtherPricingOptions({ ...otherPricingOptions, [name]: 1 });
    } else {
      setOtherPricingOptions({ ...otherPricingOptions, [name]: 0 });
      setOverRidevalue(0);
    }
    // console.log(name, checked, "showOthersPricingOptions");
  };

  // console.log(otherPricingOptions, "otherPricingOptions")
  // show all variations -
  const handleShowAllVariations = () => {
    if (paramObject.id > 0) {
      setLoading(true);
      axios
        .get(
          `${config.itemsBaseUrl}/items/pricingfindbyid?id=${paramObject.id}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              "Access-Control-Allow-Origin": "*",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          if (res.data.ResponseCode === "SUCCESS") {
            setTierVariation(res.data.ResponseData.RoleTiers);
            var variationPriceingMapedArray =
              res.data.ResponseData?.Itemvaritions?.map((obj) => {
                return {
                  ...obj,
                  IsShowMore: false,
                };
              });
            setVariationPricing(variationPriceingMapedArray);
            // setAccountingDetails()
            const {
              Costprice,
              Unitprice,
              promoprice,
              Startdate,
              Enddate,
              Commission,
              Commissiontype,
              CommissionPercentCalculationMethod,
            } = res.data.ResponseData.Items[0];
            setOtherOption({
              ...otherOption,
              costPriceDetail: Costprice,
              sellPriceDetail: Unitprice,
              promopriceDetail: promoprice,
              promoStartDateDetail: Startdate,
              promoEndDateDetail: Enddate,
              commissionDetail: Commission,
              commissionTypeDetail: Commissiontype,
              CommissionPercentCalculationMethod:
                CommissionPercentCalculationMethod,
            });
          } else if (
            res.data.ResponseCode === "ERROR" &&
            res.data.ResponseID === -1
          ) {
            toastError(ERROR_EXISTS);
            setLoading(false);
          } else {
            toastError(ERROR_MESSAGE);
            setLoading(false);
          }
        });
    } else {
    }
  };

  console.log("otherOption", otherOption); //important obj-
  console.log("tierVariation", tierVariation);

  // use effect-
  useEffect(() => {
    // handleShowAllVariations()
    AccountAPI();
  }, []);

  // show see more-
  const [visibility, setVisibility] = useState({});

  const toggleVisibility = (rowIndex) => {
    setVisibility((prevVisibility) => ({
      ...prevVisibility,
      [rowIndex]: !prevVisibility[rowIndex],
    }));
  };

  // ---------All Tier---------
  const { costPrice, sellPrice } = tierPrices;
  console.log("tierPrices", costPrice, sellPrice);

  // ---*****------default tier -----*****------
  const [defaultTierPrice, setDefaultTierPrice] = useState({
    cost: "",
    sell: "",
  });

  // handle change default tier -
  const handleChangeDefaultTier = (e) => {
    console.log("Call ==>", e.name, e.value);
    const { name, value } = e.target;
    setDefaultTierPrice({ ...defaultTierPrice, [name]: value });
  };

  console.log(defaultTierPrice, "defaultTierPrice");
  // destructure default tier-
  const { cost, sell } = defaultTierPrice;

  const [smallLoader, setSmallLoader] = useState({
    Tier1: false,
    Promo: false,
    Next: false,
    Save: false,
    tierLoader: [false, false, false, false, false],
  });

  // handle click default tier-
  const handleClickTier1 = () => {
    setSmallLoader({ ...smallLoader, Tier1: true });
    console.log(tierPrices, "tierPrices");

    // set default tier price-
    const addOtherSection = variationPricing?.map((obj) => {
      return {
        ...obj,
        CostPrice: parseFloat(cost).toFixed(2), // Added by Nilesh
        UnitPrice: parseFloat(sell).toFixed(2), // Added by Nilesh
      };
    });
    setVariationPricing(addOtherSection);
    setTimeout(() => {
      setSmallLoader({ ...smallLoader, Tier1: false });
    }, 500);
  };

  console.log("variationPricing 329", cost, sell);
  // all tiers maximum 5-

  // -----****------ Other Pricing Option (Promo) -----****------
  const [promo, setPromo] = useState({
    promoprice: 0,
    promoStartDate: "",
    promoEndDate: "",
    commission: "",
    commissionType: "",
    commissionPercentCalculation: "",
    CommissionPercentCalculationMethod: "Percentage",
    incomeAccount: 0,
    IncomeAccountDescription: "",
    expenseAccount: 0,
    ExpenseAccountDescription: "",
    inventoryAssetsAccount: 0,
    InventoryAssetsDescription: "",
    taxgroup: 0,
  });

  const handleClickOnTaxGroup = ({ value }) => {
    // console.log(value, "handleClickOnTaxGroup");
    // setTaxGroupValue(value);
    setPromo({ ...promo, taxgroup: value });
  };

  // console.log(promo, formValues, "promo456");

  // handle change promo-
  const handleChangePromo = (e) => {
    // console.log("277 Pricing", e.target);
    // console.log("277 Pricing", e.target.value);

    const { name, value } = e.target;
    setPromo({ ...promo, [name]: value });
  };

  const handleChangePromoAccount = (e, name) => {
    // console.log("277 Pricing", e?.target?.name);
    // console.log("277 Pricing", e?.target?.value);
    let value = "";
    if (name == undefined) {
      name = e?.target?.name;
    } else if (e.value == undefined) {
      value = e?.target?.value;
    } else if (e.value) {
      value = e.value;
    }
    // const { name, value } = e.target;
    setPromo({ ...promo, [name]: value });
  };

  //handle change promo Tax
  const handleChangePromoTax = (e) => {
    // console.log("277 Pricing", e);
    // console.log("277 Pricing", e.target.value);

    const { name, value } = e.target;
    setTaxItem({ ...taxItem, [name]: value });
  };

  // console.log("promo 281", promo);
  // console.log("taxItem", taxItem);

  // destructure promo-
  const { promoprice, promoStartDate, promoEndDate } = promo;

  // handle click promo-
  const handleClickPromo = () => {
    setSmallLoader({ ...smallLoader, Promo: true });
    setTierPrices({
      ...tierPrices,
      promoprice,
      PromoStartDate: promoStartDate,
      PromoEndDate: promoEndDate,
    });
    // set promo-
    const setPromo = variationPricing?.map((obj) => {
      return {
        ...obj,
        promoprice,
        PromoStartDate: promoStartDate,
        PromoEndDate: promoEndDate,
      };
    });
    setVariationPricing(setPromo);
    setTimeout(() => {
      setSmallLoader({ ...smallLoader, Promo: false });
    }, 500);
  };

  // console.log("setVariationPricing 440 ===>", variationPricing);

  // -----*----- all tiers max (5) -----*-----
  // discount value change 1-
  function handleAllTierDiscountValueChange(index, event) {
    const newValues = [...allTierDiscountValues];
    newValues[index] = event.target.value;
    setAllTierDiscountValues(newValues);
  }

  // console.log("allTierDiscountValues", allTierDiscountValues); // imp1

  // discount type change 2-

  function handleAllTierDiscountTypeChange(index, event) {
    const newValues = [...allTierDiscountType];
    newValues[index] = event?.target?.value;
    setAllTierDiscountType(newValues);
  }
  // console.log("allTierDiscountType", allTierDiscountType); // imp2

  // tier type change 3-
  const [allTierType, setAllTierType] = useState([
    "Tier1",
    "Tier2",
    "Tier3",
    "Tier4",
    "Tier5",
  ]);

  function handleAllTierTypeChange(index, code) {
    const newValues = [...allTierType];
    newValues[index] = code;
    setAllTierType(newValues);
  }
  // console.log("allTierType 485", allTierType); // imp3
  // tier handle Calculated Value-
  const [calculatedValue, setCalculatedValue] = useState([]);
  function handleCalculatedValue(index, calValue) {
    const newValues = [...calculatedValue];
    newValues[index] = calValue;
    setCalculatedValue(newValues);
  }

  // console.log("calculatedValue", calculatedValue); // imp4

  // combine three array -
  const [tierInfo, setTierInfo] = useState([]);

  const array1 = allTierDiscountValues;
  const array2 = allTierDiscountType;
  const array3 = allTierType;
  // console.log(array1, "array1 7979");
  // console.log(array2, "array2 7979");
  // console.log(array3, "array3 7979");

  // Combine arrays into an array of objects-
  let combinedArray = array1?.map((element, index) => ({
    discountV: element || 0,
    discountT: array2[index] || "",
    Code: array3[index] || "",
  }));

  // console.log("combinedArray", combinedArray);

  // let's combine both array and create a araay of object-
  const keys = allTierDiscountValues;
  const values = allTierDiscountType;

  const allTierDiscount = keys?.map((key, index) => {
    if (sell > 0) {
      var result =
        values[index] === "Fixed" && key <= sellPrice
          ? key
          : "You can't type more than sell price";
      // console.log("result======================", result);

      return {
        discountValue: key,
        discountType: values[index],
        isLoading: false,
      };
    } else {
      return "Selling Price should greater than 0";
    }
  });

  // console.log("allTierDiscount", allTierDiscount);

  // take a state to set index for setting these values in Price Variation-
  const [tierDiscount, setTierDiscount] = useState([allTierDiscount]);

  // function for handling all tier discount-
  const handleApplyTierDiscount = (index, code) => {
    console.log(combinedArray[index], "combinedArray 492");
    // on click we are getting tier wise data-
    let getAppropriateObj = allTierDiscount?.filter((el, i) => i === index);
    setSmallLoader({
      ...smallLoader,
      tierLoader: { ...smallLoader.tierLoader, [index]: true },
    });

    // console.log("getAppropriateObj 531", getAppropriateObj, code);
    setTierDiscount([allTierDiscount]);
    // console.log("tierDiscount-341", tierDiscount);

    let x = 0;
    // calculation part-
    if (getAppropriateObj[0]?.discountType === "Percentage") {
      x = ((Number(getAppropriateObj[0]?.discountValue) * sell) / 100).toFixed(
        2
      );
      x = sell - x;
      // console.log("NewupdatedValue", x);
      const existingTierVariationIndex = tierVariation?.findIndex(
        (item) => item.Code == code
      );
      if (existingTierVariationIndex != -1) {
        const existingTierVariation = tierVariation[existingTierVariationIndex];
        existingTierVariation.discount = x;

        const updatedTierVariation = [...tierVariation];
        updatedTierVariation[existingTierVariationIndex] =
          existingTierVariation;
        setTierVariation(updatedTierVariation);
      }
    } else if (getAppropriateObj[0]?.discountType === "Fixed") {
      x = (sell - Number(getAppropriateObj[0]?.discountValue)).toFixed(2);
      // console.log("NewupdatedValue", x);
      const existingTierVariationIndex = tierVariation?.findIndex(
        (item) => item.Code == code
      );
      if (existingTierVariationIndex != -1) {
        const existingTierVariation = tierVariation[existingTierVariationIndex];
        existingTierVariation.discount = x;

        const updatedTierVariation = [...tierVariation];
        updatedTierVariation[existingTierVariationIndex] =
          existingTierVariation;
        setTierVariation(updatedTierVariation);
      }
    }

    let tierPriceSection = [];
    let addOtherSection = [];
    if (code == "Tier1") {
      tierPriceSection = {
        ...tierPrices,
        Tier1: x,
      };
      addOtherSection = variationPricing?.map((obj) => {
        return {
          ...obj,
          Tier1: x,
        };
      });
    } else if (code == "Tier2") {
      tierPriceSection = {
        ...tierPrices,
        Tier2: x,
      };
      addOtherSection = variationPricing?.map((obj) => {
        return {
          ...obj,
          Tier2: x,
        };
      });
    } else if (code == "Tier3") {
      tierPriceSection = {
        ...tierPrices,
        Tier3: x,
      };
      addOtherSection = variationPricing?.map((obj) => {
        return {
          ...obj,
          Tier3: x,
        };
      });
    } else if (code == "Tier4") {
      tierPriceSection = {
        ...tierPrices,
        Tier4: x,
      };
      addOtherSection = variationPricing?.map((obj) => {
        return {
          ...obj,
          Tier4: x,
        };
      });
    } else if (code == "Tier5") {
      tierPriceSection = {
        ...tierPrices,
        Tier5: x,
      };
      addOtherSection = variationPricing?.map((obj) => {
        return {
          ...obj,
          Tier5: x,
        };
      });
    }

    setTierPrices(tierPriceSection);
    setVariationPricing(addOtherSection);
    setTimeout(() => {
      setSmallLoader({
        ...smallLoader,
        tierLoader: { ...smallLoader.tierLoader, [index]: false },
      });
    }, 500);
  };

  // Chart of acount-
  const [chartOfAccountDropdown, setChartOfAccountDropdown] = useState();
  const AccountAPI = () => {
    // chart of Account Dropdown for account id
    axios
      .get(`${config.accountingBaseUrl}/chartofaccounts/accountddl`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        // console.log("res.data.ResponseData == 441", res.data.ResponseData);
        setChartOfAccountDropdown(res.data.ResponseData);
        let accountList = [];
        const Tags = res?.data?.ResponseData?.map((u, i) => {
          accountList[i] = { label: u.Name, value: u.ID };
        });
        setChartOfAccountDropdown(accountList);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  // console.log("variationPricing", variationPricing);
  // console.log("chartOfAccountDropdown", chartOfAccountDropdown);

  // console.log("taxGroup", taxGroup);
  // Tax Group DropDown
  let taxGroupOptions = [];
  const TaxGroupDropDown = taxGroup?.map((utex, index) => {
    taxGroupOptions[index] = {
      label: utex.Name,
      value: utex.ID,
    };
  });

  // Commission Type Dropdown
  const commissionOption = [
    { label: "Percentage", value: 1 },
    { label: "Fixed Amount", value: 2 },
  ];

  //Commission Percentage Calculation Dropdown
  const commissionPercentCalculationMethodOption = [
    { label: "Selling Price", value: 1 },
    { label: "Profit", value: 2 },
  ];

  // Styles
  const selectStyles = {
    // dropdown input css
    control: (provided, state) => ({
      ...provided,
      width: "100%",
      height: "40px",
      position: "relative",
      border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
      boxShadow: state.isFocused ? "none" : "inset 0 1px 0 rgba(0, 0, 0, 0.1)", // remove box shadow when hovering
      "&:hover": {
        border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
      },
    }),
    // dropdown menu css
    menu: () => ({
      boxShadow: "inset 0 1px 0 rgba(255, 149, 0, 0.1)",
      position: "absolute",
      "z-index": "999",
      background: "#f8f8f8",
      width: "100%",
    }),
    // dropdown option css
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? "rgba(255, 149, 0, 0.1)" : "#fff", // change hover color to light orange
      "&:hover": {
        backgroundColor: "rgba(255, 149, 0, 0.1)", // change hover color to light orange
      },
    }),
  };
  function handleButtonClick() {
    if (buttonRef.current) {
      handleSubmitForm();
    }
  }
  // Back button function to move backward
  const handleBack = () => {
    props.previousStep();
    window.scrollTo(0, 0);
  };
  // Function tot handle all the variation values
  const handleVariationInput = (event, index) => {
    let name, values;

    name = event.target.name;
    values = event.target.value;

    // console.log(index, name, values);
    let cardInput = [...variationInputValues];
    if (cardInput[index]) {
      cardInput[index][name] = values;
      setVariationInputValues(cardInput);
    }
  };

  // Function to handle Change price checkbox
  const handleChangePrice = (event) => {
    setChangePrice(!changePrice);

    if (event.target.checked === true) {
      setChangePriceValues(1);
    } else {
      setChangePriceValues(0);
    }
  };

  // Function to handle Tax Cummlative checkbox
  const handleTaxCummlative = (event) => {
    setTaxCummlative(!taxCummlative);

    if (event.target.checked === true) {
      setTaxCummlativeValues(1);
    } else {
      setTaxCummlativeValues(0);
    }
  };

  // Function to handle Allow Items checkbox
  const handleAllowItems = (event) => {
    setAllowItems(!allowItems);

    if (event.target.checked === true) {
      setAllowItemsValues(1);
    } else {
      setAllowItemsValues(0);
    }
  };

  // Function to handle PriceTax checkbox
  const handlePriceTax = (event) => {
    setPriceTax(!priceTax);

    if (event.target.checked === true) {
      setPriceTaxValues(1);
    } else {
      setPriceTaxValues(0);
    }
  };

  // Function to handle Disable Price checkbox
  const handleDisablePrice = (event) => {
    setDisablePrice(!disablePrice);

    if (event.target.checked === true) {
      setDisablePriceValues(1);
    } else {
      setDisablePriceValues(0);
    }
  };

  // Function to handle Allow Price checkbox
  const handleAllowPrice = (event) => {
    setAllowPrice(!allowPrice);

    if (event.target.checked === true) {
      setAllowPriceValues(1);
    } else {
      setAllowPriceValues(0);
    }
  };

  // Function to handle Default Tax checkbox
  const handleOverDefaultTax = (event) => {
    setOverDefaultTax(!overDefaultTax);

    if (event.target.checked === true) {
      setOverDefaultTaxValues(1);
    } else {
      setOverDefaultTaxValues(0);
    }
  };

  // Function to handle Default Commision checkbox
  const handleOverrideDefaultCommission = (event) => {
    setOverrideDefaultCommission(!overrideDefaultCommission);

    if (event.target.checked === true) {
      setOverrideDefaultCommissionValues(1);
    } else {
      setOverrideDefaultCommissionValues(0);
    }
  };

  // To handle all the taxes values
  const handleChangeForValues = (event) => {
    let name, values;
    // console.log(event.target.name, event.target.value);

    name = event.target.name;
    values = event.target.value;

    // console.log(0, name, values);
    let cardInput = taxItem;

    if (cardInput) {
      cardInput[name] = values;
      // console.log("cardInput ==>", cardInput);
      setTaxItem(cardInput);
    }
  };

  // To handle all the dropdown values onChange
  const handleDropDown = (event, fieldName) => {
    let values;

    values = event.value;
    // console.log(fieldName, values);

    if (fieldName === "TaxGroup") {
      setTaxGroupValues(values);
    } else if (fieldName === "CommissionType") {
      setCommissionTypeValues(values);
    } else if (fieldName === "CommissionPercentCalculationMethod") {
      setCommissionPercentCalculationMethodValues(values);
    }
  };

  // Validation for the form
  const validationSchema = Yup.object().shape({
    CostPrice: Yup.number().required("Cost Price is required"),
    SellingPrice: Yup.number().required("Selling Price is required"),
  });

  // Handle Submit function called when the form is submitted
  // const handleSubmitForm = () => {
  //   setSubmitEvent(1);
  // const {promoprice, promoEndDate, promoStartDate} = variationPricing;
  // };

  const handleSubmitForm = (values) => {
    //setSubmitEvent(1);
    // To check whether all the string all the jsonstring are better-
    let tier1Object = combinedArray.filter((e) => e.Code === "Tier1");
    let tier2Object = combinedArray.filter((e) => e.Code === "Tier2");
    let tier3Object = combinedArray.filter((e) => e.Code === "Tier3");
    let tier4Object = combinedArray.filter((e) => e.Code === "Tier4");
    let tier5Object = combinedArray.filter((e) => e.Code === "Tier5");

    // console.log(tier1Object, "tier1Object 7878");
    // console.log(tier2Object, "tier2Object 7878");

    const tier1Value =
      tier1Object[0]?.discountT === "Fixed"
        ? Number(sell) - Number(tier1Object[0]?.discountV)
        : Number(sell) -
          (Number(sell) * Number(tier1Object[0]?.discountV)) / 100;
    const tier2Value =
      tier2Object[0]?.discountT === "Fixed"
        ? Number(sell) - Number(tier2Object[0]?.discountV)
        : Number(sell) -
          (Number(sell) * Number(tier2Object[0]?.discountV)) / 100;
    const tier3Value =
      tier3Object[0]?.discountT === "Fixed"
        ? Number(sell) - Number(tier3Object[0]?.discountV)
        : Number(sell) -
          (Number(sell) * Number(tier3Object[0]?.discountV)) / 100;
    const tier4Value =
      tier4Object[0]?.discountT === "Fixed"
        ? Number(sell) - Number(tier4Object[0]?.discountV)
        : Number(sell) -
          (Number(sell) * Number(tier4Object[0]?.discountV)) / 100;
    const tier5Value =
      tier5Object[0]?.discountT === "Fixed"
        ? Number(sell) - Number(tier5Object[0]?.discountV)
        : Number(sell) -
          (Number(sell) * Number(tier5Object[0]?.discountV)) / 100;

    // console.log("combinedArray", combinedArray)
    // console.log(
    //   "x 740 ===+",
    //   tier1Object,
    //   tier2Object,
    //   tier3Object,
    //   tier4Object,
    //   tier5Object,
    //   combinedArray
    // );
    // Pricing Upsert API Call

    const result = [];
    let obj = taxItem;

    for (let i = 1; i <= 5; i++) {
      const taxId = obj[`tax${i}id`];
      const taxName = obj[`tax${i}`];
      const taxPercent = obj[`tax${i}Value`];
      const taxType = obj[`taxType${i}`];

      result.push({
        TaxId: taxId || 0,
        TaxName: taxName,
        TaxPercent: taxPercent,
        TaxCumulative: taxCummlative || 0,
        TaxType: taxType,
      });
    }

    // console.log("variationInputValues 2233", variationInputValues);
    // console.log("variationPricing 792 =>", variationPricing);

    const updatedVariationData = variationPricing?.map((obj) => {
      return {
        ...obj,

        PromoPrice: parseFloat(obj.promoprice),
        PromoEndDate: obj.PromoEndDate,
        PromoStartDate: obj.PromoStartDate,
      };
    });

    // console.log("updatedVariationData: 2233 ", updatedVariationData);

    // console.log(result, "resultTaxData 9340");

    // To filter all null values of Location data
    let TaxPricing = result.filter(function (taxPricing) {
      return taxPricing.TaxName !== "";
    });

    let VariationData = updatedVariationData.filter(function (variationValue) {
      return variationValue.CostPrice !== "";
    });

    // console.log(VariationData, "VariationData final 2233");

    // XML object declare-
    const taxpricingobj = {};
    const variationpricingobj = {};

    // console.log(TaxPricing, "TaxPricing 9340");

    // After filtering the array to set to particular object-
    taxpricingobj.itemtaxxml = TaxPricing;
    variationpricingobj.itemvariationxml = VariationData;

    // Object are converted to JSON string-
    let taxpricingjsonstring = JSON.stringify(taxpricingobj);
    let variationpricingjsonstring = JSON.stringify(variationpricingobj);

    // console.log(taxpricingjsonstring, "taxpricingjsonstring 9340");
    // console.log(
    //   "commissionpercentcalculationmethod: 988",
    //   promo.CommissionPercentCalculationMethod,
    //   formValues.commissionPercentCalculationMethod
    // );

    const payload = {
      xmlitemtax: taxpricingjsonstring,
      xmlitemvariation: variationpricingjsonstring,
      itemid: paramObject.id,
      costprice: defaultTierPrice.cost || formValues.cost,
      unitprice: defaultTierPrice.sell || formValues.sell,
      promoprice: promo.promoprice || formValues.promoprice,
      startdate: promo.promoStartDate || formValues.promoStartDate,
      enddate: promo.promoEndDate || formValues.promoEndDate,
      disablefrompricerules: disablePriceValues,
      allowpriceoverrideregardlessofpermissions: allowPriceValues,
      taxincluded: priceTaxValues,
      allowitemstobesoldinwholenumbers: allowItemsValues,
      changecostprice: changePriceValues,
      commission: promo.commission || formValues.commission,
      commissiontype: promo.commissionType || formValues.commissionType,
      allowpromotionoffer: otherPricingOptions?.AllowPromotionOffer,
      overridedefaultcommission: otherPricingOptions?.Overridedefaultcommission,
      overridedefaulttax: otherPricingOptions?.Overridedefaulttax,
      commissionpercentcalculationmethod:
        promo.CommissionPercentCalculationMethod ||
        formValues.commissionPercentCalculationMethod,
      // commissionpercentcalculationmethod: "Fixed",
      taxgroup: promo.taxgroup,
      loginuserid: Id,

      tier1: parseFloat(tier1Object[0]?.discountV) || formValues.Tier1,
      tier1type: tier1Object[0]?.discountT || formValues.Tier1Type,
      tier1value: tier1Value || 0,

      tier2: parseFloat(tier2Object[0]?.discountV) || formValues.Tier2,
      tier2type: tier2Object[0]?.discountT || formValues.Tier2Type,
      tier2value: tier2Value || 0,

      tier3: parseFloat(tier3Object[0]?.discountV) || formValues.Tier3,
      tier3type: tier3Object[0]?.discountT || formValues.Tier3Type,
      tier3value: tier3Value || 0,

      tier4: parseFloat(tier4Object[0]?.discountV) || formValues.Tier4,
      tier4type: tier4Object[0]?.discountT || formValues.Tier4Type,
      tier4value: tier4Value || 0,

      tier5: parseFloat(tier5Object[0]?.discountV) || formValues.Tier5,
      tier5type: tier5Object[0]?.discountT || formValues.Tier5Type,
      tier5value: tier5Value || 0,

      ItemAccountID: promo.IncomeAccountID || formValues.IncomeAccountID,
      IncomeAccountDescription:
        promo.IncomeAccountDescription || formValues.IncomeAccountDescription,
      ExpenseAccountID: promo.ExpenseAccountID || formValues.ExpenseAccountID,
      ExpenseAccountDescription:
        promo.ExpenseAccountDescription || formValues.ExpenseAccountDescription,
      InventoryAssetsAccountID:
        promo.InventoryAssetsAccountID || formValues.InventoryAssetsAccountID,
      InventoryAssetsDescription:
        promo.InventoryAssetsDescription ||
        formValues.InventoryAssetsDescription,
    };

    // console.log("payload - 798", payload);

    setSmallLoader({ ...smallLoader, Save: true });
    setLoading(true);
    axios
      .post(`${config.itemsBaseUrl}/items/pricingupsert`, payload, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((res) => {
        setLoading(false);
        setSmallLoader({ ...smallLoader, Save: false });
        if (res.data.ResponseCode === "SUCCESS" && res.data.ResponseID > 0) {
          toastSuccess(SUCCESS_MESSAGE);
        } else if (
          res.data.ResponseCode === "ERROR" &&
          res.data.ResponseID === -1
        ) {
          toastError("Name" + ALREADY_EXIST);
        } else {
          toastError(ERROR_MESSAGE);
        }
        if (SubmitEvent === 1) {
          setSubmitEvent(0);
        } else {
          props.nextStep();
          window.scrollTo(0, 0);
        }
      })
      .catch((error) => {
        setSmallLoader({ ...smallLoader, Save: false });
        setLoading(false);
        // console.log("error: ", error);
      });
  };

  // To bind all the data om page load
  useEffect(() => {
    //  Binding TaxGroup DropDown
    axios
      .get(`${config.generalBaseUrl}/generals/taxesdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        // console.log("res.data.ResponseData 847", res.data.ResponseData);
        setTaxGroup(res.data.ResponseData);
      })
      .catch((err) => {
        // console.log("error: " + err);
      });

    // This constion will always be true because there is always the update case
    if (paramObject.id > 0) {
      setLoading(true);

      // API for pricingfindbyid to bind the particular data according to particular "ItemID"
      axios
        .get(
          `${config.itemsBaseUrl}/items/pricingfindbyid?id=${paramObject.id}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          setLoading(false);
          let itemsData = res?.data?.ResponseData?.Items[0];

          setFormValues({
            cost: Number(itemsData?.Costprice).toFixed(2), //Number(itemsData?.Costprice).toFixed(2),
            sell: Number(itemsData?.Unitprice).toFixed(2),
            promoprice: Number(itemsData?.promoprice).toFixed(2),
            promoStartDate: itemsData?.Startdate?.slice(0, 10),
            promoEndDate: itemsData?.Enddate?.slice(0, 10),
            DisablePrice: "",
            AllowPrice: "",
            PriceTax: "",
            AllowItems: "",
            ChangePrice: "",
            Override: "",
            commission: Number(itemsData?.Commission).toFixed(2),
            commissionType: itemsData?.Commissiontype,

            commissionPercentCalculationMethod:
              itemsData?.CommissionPercentCalculationMethod,
            OverrideTax: itemsData?.Overridedefaulttax,
            Tier1: itemsData?.Tier1,
            Tier1Type: itemsData?.Tier1Type,
            Tier1Value: itemsData.Tier1Value,
            Tier2: itemsData?.Tier2,
            Tier2Type: itemsData?.Tier2Type,
            Tier2Value: itemsData?.Tier2Value,
            Tier3: itemsData?.Tier3,
            Tier3Type: itemsData?.Tier3Type,
            Tier3Value: itemsData?.Tier3Value,
            Tier4: itemsData?.Tier4,
            Tier4Type: itemsData?.Tier4Type,
            Tier4Value: itemsData?.Tier4Value,
            Tier5: itemsData?.Tier5,
            Tier5Type: itemsData?.Tier5Type,
            Tier5Value: itemsData?.Tier5Value,
            taxgroup: itemsData?.TaxGroup,
            InventoryAssetsDescription: itemsData?.InventoryAssetsDescription,
            InventoryAssetsAccountID: itemsData?.InventoryAssetsAccountID,
            ExpenseAccountDescription: itemsData?.ExpenseAccountDescription,
            ExpenseAccountID: itemsData?.ExpenseAccountID,
            IncomeAccountDescription: itemsData?.IncomeAccountDescription,
            IncomeAccountID: itemsData?.IncomeAccountID,
            tax1: res?.data?.ResponseData?.Itemstaxes[0]?.Name,
            tax2: res?.data?.ResponseData?.Itemstaxes[1]?.Name,
            tax3: res?.data?.ResponseData?.Itemstaxes[2]?.Name,
            tax4: res?.data?.ResponseData?.Itemstaxes[3]?.Name,
            tax5: res?.data?.ResponseData?.Itemstaxes[4]?.Name,

            tax1Value: parseFloat(
              res?.data?.ResponseData?.Itemstaxes[0]?.Percent
            ),
            tax2Value: parseFloat(
              res?.data?.ResponseData?.Itemstaxes[1]?.Percent
            ),
            tax3Value: parseFloat(
              res?.data?.ResponseData?.Itemstaxes[2]?.Percent
            ),
            tax4Value: parseFloat(
              res?.data?.ResponseData?.Itemstaxes[3]?.Percent
            ),
            tax5Value: parseFloat(
              res?.data?.ResponseData?.Itemstaxes[4]?.Percent
            ),

            tax1id: res?.data?.ResponseData?.Itemstaxes[0]?.ID,
            tax2Id: res?.data?.ResponseData?.Itemstaxes[1]?.ID,
            tax3Id: res?.data?.ResponseData?.Itemstaxes[2]?.ID,
            tax4Id: res?.data?.ResponseData?.Itemstaxes[3]?.ID,
            tax5Id: res?.data?.ResponseData?.Itemstaxes[4]?.ID,

            taxType1: res?.data?.ResponseData?.Itemstaxes[0]?.TaxType,
            taxType2: res?.data?.ResponseData?.Itemstaxes[1]?.TaxType,
            taxType3: res?.data?.ResponseData?.Itemstaxes[2]?.TaxType,
            taxType4: res?.data?.ResponseData?.Itemstaxes[3]?.TaxType,
            taxType5: res?.data?.ResponseData?.Itemstaxes[4]?.TaxType,

            AllowPromotionOffer: itemsData.AllowPromotionOffer == 1 ? 1 : 0,
            Overridedefaultcommission:
              itemsData.Overridedefaultcommission == 1 ? 1 : 0,
            Overridedefaulttax: itemsData.Overridedefaulttax == 1 ? 1 : 0,
          });

          setOtherPricingOptions({
            AllowPromotionOffer: itemsData.AllowPromotionOffer == 1 ? 1 : 0,
            Overridedefaultcommission:
              itemsData.Overridedefaultcommission == 1 ? 1 : 0,
            Overridedefaulttax: itemsData.Overridedefaulttax == 1 ? 1 : 0,
          });

          setDefaultTierPrice({
            cost: Number(itemsData?.Costprice).toFixed(2), //Number(itemsData?.Costprice).toFixed(2),
            sell: Number(itemsData?.Unitprice).toFixed(2),
          });

          setVariationPricing({
            ...variationPricing,
            promoprice: Number(itemsData?.promoprice).toFixed(2),
            PromoStartDate: itemsData?.Startdate?.slice(0, 10),
            PromoEndDate: itemsData?.Enddate?.slice(0, 10),
          });
          setPromo({
            ...promo,
            promoprice: Number(itemsData?.promoprice).toFixed(2),
            promoStartDate: itemsData?.Startdate?.slice(0, 10),
            promoEndDate: itemsData?.Enddate?.slice(0, 10),
            commission: Number(itemsData?.Commission).toFixed(2),
            commissionType: itemsData?.Commissiontype,
            CommissionPercentCalculationMethod:
              itemsData?.CommissionPercentCalculationMethod,
            IncomeAccountID: itemsData?.IncomeAccountID,
            IncomeAccountDescription: itemsData?.IncomeAccountDescription,

            ExpenseAccountID: itemsData?.ExpenseAccountID,
            ExpenseAccountDescription: itemsData?.ExpenseAccountDescription,

            InventoryAssetsAccountID: itemsData?.InventoryAssetsAccountID,
            InventoryAssetsDescription: itemsData?.InventoryAssetsDescription,

            commissionType: itemsData?.Commissiontype,
            CommissionPercentCalculationMethod:
              itemsData?.CommissionPercentCalculationMethod,

            taxgroup: itemsData?.TaxGroup,
          });

          // console.log("itemsData? 1250", itemsData);

          const newValues = [...allTierDiscountType];
          if (itemsData?.Tier1Type) {
            newValues[0] = itemsData?.Tier1Type;
          }
          if (itemsData?.Tier2Type) {
            newValues[1] = itemsData?.Tier2Type;
          }
          if (itemsData?.Tier3Type) {
            newValues[2] = itemsData?.Tier3Type;
          }
          if (itemsData?.Tier4Type) {
            newValues[3] = itemsData?.Tier4Type;
          }
          if (itemsData?.Tier5Type) {
            newValues[4] = itemsData?.Tier5Type;
          }
          setAllTierDiscountType(newValues);

          const newtireValue = [...allTierDiscountValues];
          if (itemsData?.Tier1) {
            newtireValue[0] = itemsData?.Tier1;
          }
          if (itemsData?.Tier2) {
            newtireValue[1] = itemsData?.Tier2;
          }
          if (itemsData?.Tier3) {
            newtireValue[2] = itemsData?.Tier3;
          }
          if (itemsData?.Tier4) {
            newtireValue[3] = itemsData?.Tier4;
          }
          if (itemsData?.Tier5) {
            newtireValue[4] = itemsData?.Tier5;
          }
          setAllTierDiscountValues(newtireValue);

          const tirerowvalue = [...allTierType];
          if (itemsData?.Tier1Type) {
            tirerowvalue[0] = "Tier1";
          }
          if (itemsData?.Tier2Type) {
            tirerowvalue[1] = "Tier2";
          }
          if (itemsData?.Tier3Type) {
            tirerowvalue[2] = "Tier3";
          }
          if (itemsData?.Tier4Type) {
            tirerowvalue[3] = "Tier4";
          }
          if (itemsData?.Tier5Type) {
            tirerowvalue[4] = "Tier5";
          }
          setAllTierType(tirerowvalue);

          setTierVariation(res?.data?.ResponseData?.RoleTiers);
          var variationPriceingMapedArray =
            res.data.ResponseData?.Itemvaritions?.map((obj) => {
              return {
                ...obj,
                IsShowMore: false,
              };
            });
          setVariationPricing(variationPriceingMapedArray);
          // setAccountingDetails()
          const {
            Costprice,
            Unitprice,
            promoprice,
            Startdate,
            Enddate,
            Commission,
            Commissiontype,
            CommissionPercentCalculationMethod,
          } = res.data.ResponseData.Items[0];
          setOtherOption({
            ...otherOption,
            costPriceDetail: parseFloat(Costprice).toFixed(2),
            sellPriceDetail: parseFloat(Unitprice).toFixed(2),
            promopriceDetail: parseFloat(promoprice).toFixed(2),
            promoStartDateDetail: Startdate,
            promoEndDateDetail: Enddate,
            commissionDetail: Commission,
            commissionTypeDetail: Commissiontype,
            CommissionPercentCalculationMethod:
              CommissionPercentCalculationMethod,
          });

          const taxdata = {
            tax1: res.data.ResponseData.Itemstaxes[0].Name,
            tax2: res.data.ResponseData.Itemstaxes[1].Name,
            tax3: res.data.ResponseData.Itemstaxes[2].Name,
            tax4: res.data.ResponseData.Itemstaxes[3].Name,
            tax5: res.data.ResponseData.Itemstaxes[4].Name,

            tax1Value: parseFloat(res.data.ResponseData.Itemstaxes[0].Percent),
            tax2Value: parseFloat(res.data.ResponseData.Itemstaxes[1].Percent),
            tax3Value: parseFloat(res.data.ResponseData.Itemstaxes[2].Percent),
            tax4Value: parseFloat(res.data.ResponseData.Itemstaxes[3].Percent),
            tax5Value: parseFloat(res.data.ResponseData.Itemstaxes[4].Percent),

            tax1id: res.data.ResponseData.Itemstaxes[0].ID,
            tax2Id: res.data.ResponseData.Itemstaxes[1].ID,
            tax3Id: res.data.ResponseData.Itemstaxes[2].ID,
            tax4Id: res.data.ResponseData.Itemstaxes[3].ID,
            tax5Id: res.data.ResponseData.Itemstaxes[4].ID,

            taxType1: res.data.ResponseData.Itemstaxes[0].TaxType,
            taxType2: res.data.ResponseData.Itemstaxes[1].TaxType,
            taxType3: res.data.ResponseData.Itemstaxes[2].TaxType,
            taxType4: res.data.ResponseData.Itemstaxes[3].TaxType,
            taxType5: res.data.ResponseData.Itemstaxes[4].TaxType,
          };

          setTaxCummlativeValues(
            res.data.ResponseData.Itemstaxes[4].Cumulative
          );
          setTaxItem(taxdata);
          setTaxCummlative(res.data.ResponseData.Itemstaxes[0].Cumulative);

          // This conditon is used to check the length of the variation to bind the values
          if (res.data.ResponseData.Itemvaritions.length <= 0) {
            axios
              .get(
                `${config.itemsBaseUrl}/items/itemsvariationslist?id=${paramObject.id}`,
                {
                  headers: {
                    "Content-Type": "application/json;charset=UTF-8",
                    Authorization: token,
                  },
                }
              )
              .then((res) => {
                setVariationItem(res.data.ResponseData.customefield);
                console.log(res.data.ResponseData, "promoprice1122");
                let items = [];
                for (
                  let i = 0;
                  i < res.data.ResponseData.customefield.length;
                  i++
                ) {
                  items.push({
                    ItemVariationId:
                      res.data.ResponseData.customefield[i].ItemVariationId,
                    ItemId: res.data.ResponseData.customefield[i].ItemId,
                    SupplierId:
                      res.data.ResponseData.customefield[i].SupplierId,
                    VariationName:
                      res.data.ResponseData.customefield[i].VariationName,
                    VariationCostPrice: parseFloat(
                      res.data.ResponseData.customefield[i].Costprice
                    ),
                    UnitPrice: parseFloat(
                      res.data.ResponseData.customefield[i].Unitprice
                    ),
                    Variationpromoprice: parseFloat(
                      res.data.ResponseData.customefield[i].promoprice
                    ),
                    VariationPromoStartDate: Moment(
                      res.data.ResponseData.customefield[i].Startdate
                    ).format("YYYY-MM-DD"),
                    VariationPromoEndDate: Moment(
                      res.data.ResponseData.customefield[i].Enddate
                    ).format("YYYY-MM-DD"),
                  });
                }
                setVariationInputValues(items);
              })
              .catch((err) => {
                console.log("Error: ", err);
                setLoading(false);
              });
          }
          // Else condition if the IF condition fails
          else {
            console.log(res.data.ResponseData.customefield, "promoprice1122");
            let items = [];
            for (
              let i = 0;
              i < res.data.ResponseData.Itemvaritions.length;
              i++
            ) {
              items.push({
                ItemVariationId: res.data.ResponseData.Itemvaritions[i].ID,
                ItemId: res.data.ResponseData.Itemvaritions[i].ItemId,
                SupplierId: res.data.ResponseData.Itemvaritions[i].SupplierId,
                VariationName: res.data.ResponseData.Itemvaritions[i].Name,
                VariationCostPrice: parseFloat(
                  res.data.ResponseData.Itemvaritions[i].Costprice
                ),
                UnitPrice: parseFloat(
                  res.data.ResponseData.Itemvaritions[i].Unitprice
                ),
                Variationpromoprice: parseFloat(
                  res.data.ResponseData.Itemvaritions[i].promoprice
                ),
                VariationPromoStartDate: Moment(
                  res.data.ResponseData.Itemvaritions[i].Startdate
                ).format("YYYY-MM-DD"),
                VariationPromoEndDate: Moment(
                  res.data.ResponseData.Itemvaritions[i].Enddate
                ).format("YYYY-MM-DD"),
                SupplierName:
                  res.data.ResponseData.Itemvaritions[i].SupplierName,
              });
            }
            setVariationInputValues(items);
          }

          const pricingdata = res.data.ResponseData.Items[0];

          console.log(pricingdata, "pricingdata");
          // For biniding the dropdown
          setSelectedCommissionType(
            res.data.ResponseData.Items[0].Commissiontype
          );
          setSelectedCommissionPercent(
            res.data.ResponseData.Items[0].CommissionPercentCalculationMethod
          );
          setSelectedTaxGroup(res.data.ResponseData.Items[0].TaxGroup);

          // For updating the data of drop down
          setCommissionPercentCalculationMethodValues(
            res.data.ResponseData.Items[0].CommissionPercentCalculationMethod
          );
          setCommissionTypeValues(
            res.data.ResponseData.Items[0].Commissiontype
          );
          setTaxGroupValues(res.data.ResponseData.Items[0].TaxGroup);

          // For handling all the check boxs
          setAllowPriceValues(
            pricingdata.Allowpriceoverrideregardlessofpermissions === 1 ? 1 : 0
          );
          setChangePriceValues(pricingdata.Changecostprice === 1 ? 1 : 0);
          setAllowItemsValues(
            pricingdata.Allowitemstobesoldinwholenumbers === 1 ? 1 : 0
          );
          setPriceTaxValues(pricingdata.TaxIncluded === 1 ? 1 : 0);
          setDisablePriceValues(
            pricingdata.Disablefrompricerules === 1 ? 1 : 0
          );
          setOverrideDefaultCommissionValues(
            pricingdata.Overridedefaultcommission === 1 ? 1 : 0
          );
          setOverDefaultTaxValues(pricingdata.Overridedefaulttax === 1 ? 1 : 0);

          const data = {
            cost:
              parseFloat(pricingdata.Costprice) > 0
                ? parseFloat(pricingdata.Costprice)
                : 0,
            SellingPrice:
              parseFloat(pricingdata.Unitprice) > 0
                ? parseFloat(pricingdata.Unitprice)
                : 0,
            promoprice:
              parseFloat(pricingdata.promoprice) > 0
                ? parseFloat(pricingdata.promoprice)
                : 0,
            PromoStartDate: Moment(pricingdata.Startdate).format("YYYY-MM-DD"),
            PromoEndDate: Moment(pricingdata.Enddate).format("YYYY-MM-DD"),
            DisablePrice: pricingdata.Disablefrompricerules,
            AllowPrice: pricingdata.Allowpriceoverrideregardlessofpermissions,
            PriceTax: pricingdata.TaxIncluded,
            AllowItems: pricingdata.Allowitemstobesoldinwholenumbers,
            ChangePrice: pricingdata.Changecostprice,
            Override: pricingdata.Overridedefaultcommission,
            Commission: parseFloat(pricingdata.Commission),
            CommissionType: pricingdata.Commissiontype,
            CommissionPercentCalculationMethod:
              pricingdata.CommissionPercentCalculationMethod,
            OverrideTax: pricingdata.Overridedefaulttax,
            TaxGroup: pricingdata.TaxGroup,
          };
          // setFormValues(data);

          // For checking of the check box
          setAllowPrice(
            pricingdata.Allowpriceoverrideregardlessofpermissions === 1
              ? true
              : false
          );
          setChangePrice(pricingdata.Changecostprice === 1 ? true : false);
          setAllowItems(
            pricingdata.Allowitemstobesoldinwholenumbers === 1 ? true : false
          );
          setPriceTax(pricingdata.TaxIncluded === 1 ? true : false);
          setDisablePrice(
            pricingdata.Disablefrompricerules === 1 ? true : false
          );
          setOverrideDefaultCommission(
            pricingdata.Overridedefaultcommission === 1 ? true : false
          );
          setOverDefaultTax(
            pricingdata.Overridedefaulttax === 1 ? true : false
          );
        })
        .catch((err) => {
          console.log("error: ", err);
        });
    }
  }, [props]);

  console.log("otherPricingOptions 1517 ==>", otherPricingOptions);

  console.log("formValues ===> 1024", formValues);

  console.log(taxGroupOptions, "taxGroupOptions");

  // This the layout of the Pricing Page

  const handleControlChange = (e, index) => {
    const updatedData = [...variationPricing];

    updatedData[index] = {
      ...updatedData[index],
      [e.target.name]: e.target.value,
    };

    setVariationPricing(updatedData);
  };
  return (
    <>
      <Loader loading={loading} />
      <div className="card p-3">
        <Formik
          {...props}
          initialValues={formValues}
          validationSchema={validationSchema}
          enableReinitialize
          onSubmit={handleSubmitForm}
        >
          {({ errors, touched, handleChange }) => (
            <Form>
              <div>
                {/* Item Pricing */}
                <div>
                  <div className="d-flex justify-content-between mt-1">
                    <h5 className="fw-bold">Item Pricing</h5>
                    <div>
                      {props.currentStep > 1 && (
                        <button
                          onClick={handleBack}
                          className="btn btn-sm btn-primary btn-md me-1"
                        >
                          Back
                        </button>
                      )}
                      {props.currentStep < props.totalSteps && (
                        <button
                          className="btn btn-sm btn-primary btn-md"
                          type="button"
                          onClick={handleButtonClick}
                        >
                          Next
                        </button>
                      )}
                    </div>
                  </div>
                  {/* Items */}
                  <div>
                    <div className="row d-flex justify-content-between align-items-end mb-1">
                      <div className="col-md-2 mb-2">
                        Default Tier Item Pricing
                      </div>
                      {checkUserPermission("show-cost-price") && (
                        <div className="col-md-3">
                          <div className="row">
                            <p>Cost Price (Without Tax)</p>
                          </div>
                          <div className="row">
                            <Field
                              id="cost"
                              name="cost"
                              className="form-control form-control-sm"
                              // value={formValues.cost}
                              // defaultValue={formValues.cost}
                              // onChange={handleChange}
                              onChange={handleChange}
                              onKeyUp={handleChangeDefaultTier}
                              type="number"
                            />
                          </div>
                        </div>
                      )}
                      <div className="col-md-3">
                        <div className="row">
                          <p>Selling Price</p>
                        </div>
                        <div className="row">
                          <Field
                            className="form-control form-control-sm"
                            id="sell"
                            name="sell"
                            // value={sell}
                            onChange={handleChange}
                            onKeyUp={handleChangeDefaultTier}
                            type="number"
                          />
                        </div>
                      </div>
                      <div className="col-md-3">
                        <Button
                          className="btn btn-sm"
                          onClick={handleClickTier1}
                          disabled={smallLoader?.Tier1}
                        >
                          {smallLoader?.Tier1 && (
                            <i class="fa fa-refresh fa-spin" />
                          )}
                          Apply this Pricing for all Variations
                        </Button>
                      </div>
                    </div>

                    {tierVariation?.map((el, index) => (
                      <div
                        key={el.ID}
                        className="row d-flex justify-content-between align-items-end mb-1"
                      >
                        <div className="col-md-2 mb-2">{el.Name}</div>
                        <div className="col-md-3">
                          <div className="row">
                            <p>Discount Value</p>
                          </div>
                          <div className="row">
                            <Field
                              className="form-control form-control-sm"
                              name={`Tier${+index + 1}`}
                              id={`Tier${+index + 1}`}
                              onInput={(event) =>
                                handleAllTierDiscountValueChange(index, event)
                              }
                              type="number"
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="row">
                            <p>Discount Type</p>
                          </div>
                          <div className="row">
                            <select
                              onChange={handleChange}
                              onInput={(event) => {
                                handleAllTierDiscountTypeChange(index, event);
                                handleAllTierTypeChange(index, el.Code);
                              }}
                              className="form-select custom-search-select"
                              name={`Tier${+index + 1}Type`}
                              id={`Tier${+index + 1}Type`}
                              value={allTierDiscountType[index]}
                            >
                              <option value={"Percentage"}>
                                Percentage (%)
                              </option>
                              <option value={"Fixed"}>Fixed</option>
                            </select>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <Button
                            className="btn btn-sm"
                            onClick={() =>
                              handleApplyTierDiscount(index, el.Code)
                            }
                            disabled={smallLoader?.tierLoader[index]}
                          >
                            {smallLoader?.tierLoader[index] && (
                              <i class="fa fa-refresh fa-spin" />
                            )}
                            Apply this Pricing for this tier
                          </Button>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Accounting Options */}
                <div>
                  <h5 className="mb-3 mt-3 fw-bold">Accounting Options</h5>
                  <div>
                    <div className="row d-flex justify-content-between align-items-center mb-2">
                      <div className="col-md-2">Income Account</div>
                      <div className="col-md-4">
                        {/* <select
                        className="form-select"
                        id="IncomeAccountID"
                        name="IncomeAccountID"
                        onChange={handleChange}
                        onInput={(e) => {
                          handleChangePromo(e);
                        }}
                      >
                        <option value={0} selected>
                          Select
                        </option>
                        {chartOfAccountDropdown?.map((el) => (
                          <option key={el.ID} value={el.ID}>
                            {el.Name}
                          </option>
                        ))}
                      </select> */}
                        <Select
                          backspaceRemovesValue={false}
                          controlShouldRenderValue={true}
                          hideSelectedOptions={true}
                          isClearable={true}
                          className="w-100 custom-search-select"
                          id="IncomeAccountID"
                          name="IncomeAccountID"
                          options={chartOfAccountDropdown}
                          // defaultValue={{ value: 0, label: "Select" }}
                          onChange={(e) =>
                            handleChangePromoAccount(e, "IncomeAccountID")
                          }
                          value={chartOfAccountDropdown?.find(
                            (option) => option?.value === promo?.IncomeAccountID
                          )}
                        />
                      </div>
                      <div className="col-md-2">
                        <p>Description</p>
                      </div>
                      <div className="col-md-4">
                        <Field
                          className="form-control form-control-sm"
                          id="IncomeAccountDescription"
                          name="IncomeAccountDescription"
                          onInput={(e) =>
                            handleChangePromoAccount(
                              e,
                              "IncomeAccountDescription"
                            )
                          }
                          onChange={handleChange}
                        />
                      </div>
                    </div>

                    <div className="row d-flex justify-content-between align-items-center mb-2">
                      <div className="col-md-2">Expense Account</div>
                      <div className="col-md-4">
                        {/* <select
                        className="form-select"
                        id="ExpenseAccountID"
                        name="ExpenseAccountID"
                        onChange={handleChange}
                        onInput={(e) => {
                          handleChangePromoAccount(e);
                        }}
                      >
                        <option value={0} selected>
                          Select
                        </option>
                        {chartOfAccountDropdown?.map((el) => (
                          <option key={el.ID} value={el.ID}>
                            {el.Name}
                          </option>
                        ))}
                      </select> */}
                        <Select
                          backspaceRemovesValue={false}
                          controlShouldRenderValue={true}
                          hideSelectedOptions={true}
                          isClearable={true}
                          className="w-100 custom-search-select"
                          id="ExpenseAccountID"
                          name="ExpenseAccountID"
                          options={chartOfAccountDropdown}
                          // defaultValue={{ value: 0, label: "Select" }}
                          onChange={(e) =>
                            handleChangePromoAccount(e, "ExpenseAccountID")
                          }
                          value={chartOfAccountDropdown?.find(
                            (option) =>
                              option?.value === promo?.ExpenseAccountID
                          )}
                          // onInputChange={(e)=>handleChangePromoAccount(e)}
                        />
                      </div>
                      <div className="col-md-2">
                        <p>Description</p>
                      </div>
                      <div className="col-md-4">
                        <Field
                          className="form-control form-control-sm"
                          id="ExpenseAccountDescription"
                          name="ExpenseAccountDescription"
                          onChange={handleChange}
                          onInput={(e) =>
                            handleChangePromoAccount(
                              e,
                              "ExpenseAccountDescription"
                            )
                          }
                        />
                      </div>
                    </div>

                    <div className="row d-flex align-items-center mb-2">
                      <div className="col-md-2">Inventory Assets Account</div>
                      <div className="col-md-4">
                        {/* <select
                        className="form-select"
                        id="InventoryAssetsAccountID"
                        name="InventoryAssetsAccountID"
                        onChange={handleChange}
                        onInput={(e) => {
                          handleChangePromoAccount(e);
                        }}
                      >
                        <option value={0} selected>
                          Select
                        </option>
                        {chartOfAccountDropdown?.map((el) => (
                          <option key={el.ID} value={el.ID}>
                            {el.Name}
                          </option>
                        ))}
                      </select> */}
                        <Select
                          backspaceRemovesValue={false}
                          controlShouldRenderValue={true}
                          hideSelectedOptions={true}
                          isClearable={true}
                          className="w-100 custom-search-select"
                          id="InventoryAssetsAccountID"
                          name="InventoryAssetsAccountID"
                          options={chartOfAccountDropdown}
                          // defaultValue={{ value: 0, label: "Select" }}
                          onChange={(e) =>
                            handleChangePromoAccount(
                              e,
                              "InventoryAssetsAccountID"
                            )
                          }
                          value={chartOfAccountDropdown?.find(
                            (option) =>
                              option?.value === promo?.InventoryAssetsAccountID
                          )}
                          // onInputChange={(e)=>handleChangePromoAccount(e)}
                        />
                      </div>
                      <div className="col-md-2">
                        <p>Description</p>
                      </div>
                      <div className="col-md-4">
                        <Field
                          className="form-control form-control-sm"
                          id="InventoryAssetsDescription"
                          name="InventoryAssetsDescription"
                          onChange={handleChange}
                          onInput={(e) =>
                            handleChangePromoAccount(
                              e,
                              "InventoryAssetsDescription"
                            )
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/* Other Pricing Options */}
                <div>
                  <h5 className="mb-3 mt-3 fw-bold">Other Pricing Options</h5>
                  <div>
                    {/* Section-1 */}
                    <div className="d-flex mb-1">
                      <label
                        class="form-check-label"
                        for="flexSwitchCheckDefault"
                      >
                        Do you offer promotion for this item?
                      </label>
                      <div class="form-check form-switch col-md-1">
                        <input
                          class="form-check-input m-auto mt-1"
                          onChange={showOthersPricingOptions}
                          name="AllowPromotionOffer"
                          type="checkbox"
                          role="switch"
                          id="flexSwitchCheckDefault"
                          checked={otherPricingOptions.AllowPromotionOffer == 1}
                        />
                      </div>
                      <label>No / Yes</label>
                    </div>
                    {otherPricingOptions.AllowPromotionOffer ? (
                      <div className="row d-flex justify-content-between align-items-end mb-3">
                        <div className="col">
                          <span>Promo Price</span>
                          <Field
                            className="form-control"
                            onChange={handleChange}
                            onKeyUp={handleChangePromo}
                            id="promoprice"
                            name="promoprice"
                            type="number"
                          />
                        </div>
                        <div className="col">
                          <span>Promo Start Date</span>
                          <Field
                            className="form-control"
                            type="date"
                            onChange={handleChange}
                            onInput={handleChangePromo}
                            id="promoStartDate"
                            name="promoStartDate"
                            // value={promoStartDate}
                          />
                        </div>
                        <div className="col">
                          <span>Promo End Date</span>
                          <Field
                            className="form-control"
                            type="date"
                            onChange={handleChange}
                            onInput={handleChangePromo}
                            id="promoEndDate"
                            name="promoEndDate"
                          />
                        </div>
                        <div className="col-md-3">
                          <Button
                            className="btn btn-sm"
                            onClick={handleClickPromo}
                            disabled={smallLoader?.Promo}
                          >
                            {smallLoader?.Promo && (
                              <i class="fa fa-refresh fa-spin" />
                            )}
                            Apply this Promo Pricing for all Variations
                          </Button>
                        </div>
                      </div>
                    ) : null}

                    {/* Section-2 */}
                    <div className="d-flex mt-3 mb-1">
                      <label
                        class="form-check-label"
                        style={{ paddingRight: "2.8rem" }}
                        for="flexSwitchCheckDefault"
                      >
                        Override Default Commission
                      </label>
                      <div class="form-check form-switch col-md-1">
                        <input
                          class="form-check-input m-auto mt-1"
                          onChange={showOthersPricingOptions}
                          name="Overridedefaultcommission"
                          type="checkbox"
                          role="switch"
                          id="flexSwitchCheckDefault"
                          checked={
                            otherPricingOptions.Overridedefaultcommission === 1
                          }
                        />
                      </div>
                      <label>No / Yes</label>
                    </div>
                    {otherPricingOptions.Overridedefaultcommission ? (
                      <div className="d-flex gap-2">
                        <div className="col">
                          <span>Commission</span>
                          <Field
                            className="form-control"
                            onChange={handleChange}
                            onInput={handleChangePromo}
                            name="commission"
                            id="commission"
                            type="number"
                          />
                        </div>
                        <div className="col">
                          <span>Select Commission Type</span>
                          <select
                            className="form-select"
                            onChange={handleChange}
                            onInput={handleChangePromo}
                            name="commissionType"
                            id="commissionType"
                            value={promo.commissionType}
                          >
                            <option value="Percentage">Percentage</option>
                            <option value="Fixed">Fixed</option>
                          </select>
                        </div>
                        <div className="col">
                          <p className="mt-4">
                            Commission Percent Calculation Method
                          </p>
                        </div>
                        <div className="col">
                          <span>Select Commission Type</span>
                          <select
                            className="form-select"
                            onChange={handleChange}
                            onInput={handleChangePromo}
                            name="CommissionPercentCalculationMethod"
                            id="CommissionPercentCalculationMethod"
                            value={promo.CommissionPercentCalculationMethod}
                          >
                            <option value="Percentage">Percentage</option>
                            <option value="Fixed">Fixed</option>
                          </select>
                        </div>
                      </div>
                    ) : null}

                    {/* Section-3 */}
                    <div className="d-flex mt-3 mb-1">
                      <label
                        class="form-check-label"
                        style={{ paddingRight: "6.2rem" }}
                        for="flexSwitchCheckDefault"
                      >
                        Override Default Tax
                      </label>
                      <div class="form-check form-switch col-md-1">
                        <input
                          class="form-check-input m-auto mt-1"
                          onChange={showOthersPricingOptions}
                          name="Overridedefaulttax"
                          type="checkbox"
                          role="switch"
                          id="flexSwitchCheckDefault"
                          checked={otherPricingOptions.Overridedefaulttax === 1}
                        />
                      </div>
                      <label>No / Yes</label>
                    </div>
                    {otherPricingOptions.Overridedefaulttax ? (
                      <>
                        <div className="d-flex align-items-baseline gap-2 mb-1">
                          <div
                            className="col-md-3 d-flex"
                            style={{ marginLeft: "14px" }}
                          >
                            <span className="col-md-3 mt-1">Tax Group</span>
                            <Select
                              onChange={(event) => {
                                handleClickOnTaxGroup(event);
                              }}
                              options={taxGroupOptions}
                              backspaceRemovesValue={false}
                              controlShouldRenderValue={true}
                              hideSelectedOptions={true}
                              isClearable={true}
                              styles={selectStyles}
                              value={taxGroupOptions?.find(
                                (option) => option?.value === promo?.taxgroup
                              )}
                            />
                          </div>
                          <div className="col"></div>
                          <div className="col"></div>
                          <div className="col"></div>
                        </div>

                        <div className="d-flex">
                          <div className="col d-flex align-items-baseline gap-2">
                            <span>Tax1</span>
                            <Field
                              className="form-control"
                              type="text"
                              onChange={handleChange}
                              onInput={handleChangePromoTax}
                              name="tax1"
                              id="tax1"
                            />
                            <Field
                              className="form-control"
                              type="number"
                              onChange={handleChange}
                              onInput={handleChangePromoTax}
                              name="tax1Value"
                              id="tax1Value"
                            />
                            <select
                              className="form-select"
                              onChange={handleChange}
                              onInput={handleChangePromoTax}
                              name="taxType1"
                              id="taxType1"
                              value={taxItem.taxType1}
                            >
                              <option value="Percentage">Percentage</option>
                              <option value="Fixed">Fixed</option>
                            </select>
                          </div>
                          <div className="col d-flex align-items-baseline gap-2">
                            <span>Tax2</span>
                            <Field
                              className="form-control"
                              type="text"
                              onChange={handleChange}
                              onInput={handleChangePromoTax}
                              name="tax2"
                              id="tax2"
                            />
                            <Field
                              className="form-control"
                              type="number"
                              onChange={handleChange}
                              onInput={handleChangePromoTax}
                              name="tax2Value"
                              id="tax2Value"
                            />
                            <select
                              className="form-select"
                              onChange={handleChange}
                              onInput={handleChangePromoTax}
                              name="taxType2"
                              id="taxType2"
                              value={taxItem.taxType2}
                            >
                              <option value="Percentage">Percentage</option>
                              <option value="Fixed">Fixed</option>
                            </select>
                          </div>
                          <div className="col d-flex align-items-baseline gap-2">
                            <span>Tax3</span>
                            <Field
                              className="form-control"
                              type="text"
                              onChange={handleChange}
                              onInput={handleChangePromoTax}
                              name="tax3"
                              id="tax3"
                            />
                            <Field
                              className="form-control"
                              type="number"
                              onChange={handleChange}
                              onInput={handleChangePromoTax}
                              name="tax3Value"
                              id="tax3Value"
                            />
                            <select
                              className="form-select"
                              onChange={handleChange}
                              onInput={handleChangePromoTax}
                              name="taxType3"
                              id="taxType3"
                              value={taxItem.taxType3}
                            >
                              <option value="Percentage">Percentage</option>
                              <option value="Fixed">Fixed</option>
                            </select>
                          </div>
                        </div>
                        <div
                          className="d-flex mt-0"
                          style={{ marginTop: "-0.2rem" }}
                        >
                          <div className="col d-flex align-items-baseline gap-2">
                            <span>Tax4</span>
                            <Field
                              className="form-control"
                              type="text"
                              onChange={handleChange}
                              onInput={handleChangePromoTax}
                              name="tax4"
                              id="tax4"
                            />
                            <Field
                              className="form-control"
                              type="number"
                              onChange={handleChange}
                              onInput={handleChangePromoTax}
                              name="tax4Value"
                              id="tax4Value"
                            />
                            <select
                              className="form-select"
                              onChange={handleChange}
                              onInput={handleChangePromoTax}
                              name="taxType4"
                              id="taxType4"
                              value={taxItem.taxType4}
                            >
                              <option value="Percentage">Percentage</option>
                              <option value="Fixed">Fixed</option>
                            </select>
                          </div>
                          <div className="col d-flex align-items-baseline gap-2">
                            <span>Tax5</span>
                            <Field
                              className="form-control"
                              type="text"
                              onChange={handleChange}
                              onInput={handleChangePromoTax}
                              name="tax5"
                              id="tax5"
                            />
                            <Field
                              className="form-control"
                              type="number"
                              onChange={handleChange}
                              onInput={handleChangePromoTax}
                              name="tax5Value"
                              id="tax5Value"
                            />
                            <select
                              className="form-select"
                              onChange={handleChange}
                              onInput={handleChangePromoTax}
                              name="taxType5"
                              id="taxType5"
                              value={taxItem.taxType5}
                            >
                              <option value="Percentage">Percentage</option>
                              <option value="Fixed">Fixed</option>
                            </select>
                          </div>
                          <div className="col d-flex align-items-baseline gap-2">
                            {/* <span>Tax5</span>
                            <Field  className="form-control" />
                            <select  className="form-select"></select> */}
                          </div>
                        </div>
                      </>
                    ) : (
                      ""
                    )}
                  </div>
                </div>

                {/* Item Variation Pricing */}
                <div className="table-responsive">
                  <h5 className="mb-3 mt-3 fw-bold">Item Variation Pricing</h5>
                  <table className="table table-bordered table-responsive-lg">
                    <thead>
                      <tr>
                        <th>Supplier</th>
                        <th>Item Name: Variations</th>
                        {checkUserPermission("show-cost-price") && (
                          <th>Cost Price</th>
                        )}
                        <th>Sale Price</th>
                        {otherPricingOptions.AllowPromotionOffer ? (
                          <th>Promo Price</th>
                        ) : null}
                        {otherPricingOptions.AllowPromotionOffer ? (
                          <th>Promo Start Date</th>
                        ) : null}
                        {otherPricingOptions.AllowPromotionOffer ? (
                          <th>Promo End Date</th>
                        ) : null}
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {variationPricing?.map((el, index) => {
                        console.log("el ==>", el);
                        console.log(
                          "el Tier 1 ==>",
                          el.Tier1,
                          " | el Tier 2 ==>",
                          el.Tier2
                        );

                        return (
                          <>
                            <tr>
                              <td>{el.SupplierName}</td>
                              <td>{el.Name}</td>
                              {checkUserPermission("show-cost-price") && (
                                <td>
                                  <input
                                    type="number"
                                    className="form-control form-control-sm"
                                    // defaultValue={el.costPrice}
                                    // defaultValue={el.CostPrice} // Changed By Nilesh
                                    // placeholder="0"
                                    // value={parseFloat(el.CostPrice).toFixed(2)}
                                    value={el.CostPrice}
                                    name="CostPrice"
                                    onChange={(e) =>
                                      handleControlChange(e, index)
                                    }
                                  />
                                </td>
                              )}
                              <td>
                                <input
                                  type="number"
                                  className="form-control form-control-sm"
                                  //defaultValue={el.sellPrice}
                                  //value={parseFloat(el.UnitPrice).toFixed(2)} // Changed By Nilesh
                                  value={el.UnitPrice} // Changed By Nilesh
                                  name="UnitPrice"
                                  onChange={(e) =>
                                    handleControlChange(e, index)
                                  }
                                  // placeholder="0"
                                />
                              </td>
                              {otherPricingOptions.AllowPromotionOffer ? (
                                <td>
                                  <input
                                    type="number"
                                    className="form-control form-control-sm"
                                    value={el.promoprice}
                                    name="promoprice"
                                    onChange={(e) =>
                                      handleControlChange(e, index)
                                    }
                                  />
                                </td>
                              ) : null}

                              {otherPricingOptions.AllowPromotionOffer ? (
                                <td>
                                  <input
                                    type="date"
                                    className="form-control form-control-sm"
                                    value={el?.PromoStartDate?.slice(0, 10)}
                                    id="PromoStartDate"
                                    name="PromoStartDate"
                                    onChange={(e) =>
                                      handleControlChange(e, index)
                                    }
                                  />
                                </td>
                              ) : null}

                              {otherPricingOptions.AllowPromotionOffer ? (
                                <td>
                                  <input
                                    type="date"
                                    className="form-control form-control-sm"
                                    // defaultValue={
                                    //   // el?.PromoEndDate?.length == 10?
                                    //     // el?.PromoEndDate:
                                    //      el?.PromoEndDate?.slice(0, 10)
                                    // }
                                    value={el?.PromoEndDate?.slice(0, 10)}
                                    // value={el.PromoEndDate.slice(0, 10)} // Changed By Nilesh
                                    name="PromoEndDate"
                                    onChange={(e) =>
                                      handleControlChange(e, index)
                                    }
                                  />
                                </td>
                              ) : null}
                              <td>
                                <button
                                  className="btn btn-outline-dark btn-sm"
                                  onClick={() => toggleVisibility(index)}
                                >
                                  {visibility[index]
                                    ? "Minimise -"
                                    : "See More +"}
                                </button>
                              </td>
                            </tr>

                            {visibility[index] ? (
                              <tr name={toString(el.ID)}>
                                <td></td>
                                <td></td>
                                {tierVariation?.map((obj, index1) => (
                                  <td key={obj.ID}>
                                    <label>{obj.Name}</label>
                                    <input
                                      type="number"
                                      className="form-control form-control-sm"
                                      //  defaultValue={el.discount}
                                      // value={el.discount} // Changed By
                                      value={
                                        obj.Code == "Tier1"
                                          ? el.Tier1
                                          : obj.Code == "Tier2"
                                          ? el.Tier2
                                          : obj.Code == "Tier3"
                                          ? el.Tier3
                                          : obj.Code == "Tier4"
                                          ? el.Tier4
                                          : obj.Code == "Tier5"
                                          ? el.Tier5
                                          : 0
                                      }
                                      name={obj.Code}
                                      onChange={(e) => {
                                        // handleCalculatedValue(index, obj.discount);  /// comented by Nilesh
                                        handleControlChange(e, index);
                                      }}
                                    />
                                  </td>
                                ))}
                              </tr>
                            ) : null}
                          </>
                        );
                      })}
                    </tbody>
                  </table>
                </div>

                {/* Next and Back Button */}
                <div className="text-center mb-2 mt-2">
                  {props.currentStep > 1 && (
                    <button
                      type="button"
                      onClick={handleBack}
                      className="btn btn-sm btn-primary me-3"
                    >
                      Back
                    </button>
                  )}
                  {props.currentStep < props.totalSteps && (
                    <button
                      type="submit"
                      className="btn btn-sm btn-primary me-3"
                      ref={buttonRef}
                      onClick={handleButtonClick}
                      disabled={loading}
                    >
                      Next
                    </button>
                  )}
                  <button
                    onClick={handleSubmitForm}
                    className="btn btn-sm btn-primary btn-md me-3"
                    id="btn_submit"
                    type="submit"
                    disabled={loading}
                  >
                    Save
                  </button>
                  <Link to="/items" className="btn btn-sm btn-secondary btn-md">
                    Cancel
                  </Link>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </>
  );
};
export default Pricing;
